namespace SPA
{
	export namespace BRW
	{
		export class Page
			extends ui.tab.TabHTMLPresentation
		{

			/**
			 * @constant No warning flags
			 */
			private static readonly SUCCESS = 0;

			/**
			 * @constant something is missing, maybe specified
			 */
			private static readonly MISSING = 10000;

			/**
			 * @constant Living area value is missing
			 */
			private static readonly MISSING_WFL = 1;
			/**
			 * @constant Bruttogrundfläche is missing
			 */
			private static readonly MISSING_BGL = 2;
			/**
			 * @constant Construction year is missing
			 */
			private static readonly MISSING_BJA = 4;
			/**
			 * @constant Plot area is missing
			 */
			private static readonly MISSING_GFL = 8;

			private mForm: 											ui.Form.Form;
			private mMPData:										ui.Box.Box;
			private mResultData: 								ui.Box.Box;
			private theObject:									Wollmilch.MP01.IObject;

			// @ts-ignore
			private Address:  									Wollmilch.PostalAddressObject;
			private ResultText:									JQuery;

			private AreaSelected: 							string|null;
			private AreaValue: 									number|null;
			private AreaSwap:										number|null;
			private Baujahr:										number|null;
			private Grundstuecksflaeche:				number|null;
			private Garage:											number|null;

			private currentobject: 							any;

			// MFH, ...
			// @ts-ignore
			private selectGebaeudetypElement:		ui.Form.Select;
			private selectGebaeudetypItem:			string;

			// Keller, Dach, ...
			private selectBauartElement:				SPA.gui.component.CheckableList;
			private selectBauartList:						any;
			private selectBauartItem:						string;

			// Kopfhaus, ...
			// @ts-ignore
			private selectBauartTypElement:			ui.Form.RadioGroup;
			private selectBauartTypList:				any;
			private selectBauartTypItem:				string;

			// einfach, mittel, ...
			// @ts-ignore
			private selectAusstattungElement:		ui.Form.Select;
			private selectAusstattungList:			any;
			private selectAusstattungItem:			string;

			private lastRequest:								any|null;
			private lastResult:									any|null;

			public constructor( BRWData: Wollmilch.MP01.IObject )
			{
				super();

				this.Initialize( {} );

				this.mMPData											= new ui.Box.Box();
				this.mResultData									= new ui.Box.Box();
				this.theObject 										= BRWData;
				this.ResultText										= ui.$$.text( app.getMessage( 'BRW.GENERAL.result_message' ) );

				this.AreaSelected 								= null;
				this.AreaValue										= null;
				this.AreaSwap											= 0;
				this.Baujahr											= null;
				this.Grundstuecksflaeche					= null;
				this.Garage												= null;

				this.selectGebaeudetypItem				= '1';
				this.selectBauartElement					= new SPA.BRW.gui.CheckableList(
					{ multiple: false, required: true, name: 'buildingkind', horizontal: true},
				);
				this.selectBauartElement.addClass( 'control-label col-xs-12 col-md-10' )
					.css( {'overflow': 'auto', 'text-align': 'center' } );
				this.selectBauartList							= [];
				this.selectBauartItem							= '1.11';

				this.selectBauartTypList 					= [];
				this.selectBauartTypItem					= '1';
				this.selectAusstattungList				= [];
				this.selectAusstattungItem				= '1';

				this.lastRequest									= null;
				this.lastResult										= null;

				Object.keys(app.getMessage( 'BRW.TYP.1.kindof' )).forEach( (element: any) =>
				{
					this.selectBauartTypList[ element ] = { value: element, title: app.getMessage( 'BRW.TYP.1.kindof' )[element] };
				});

				Object.keys(app.getMessage( 'BRW.TYP.1.equipments' )).forEach( (element: any) =>
				{
					this.selectAusstattungList[ element ] = app.getMessage( 'BRW.TYP.1.equipments' )[element];
				});

				Object.keys(app.getMessage( 'BRW.TYP.1.list' )).forEach( (element: any) =>
				{
					this.selectBauartList[ element ] = app.getMessage( 'BRW.TYP.1.list' )[element];
				});

				this.mForm = new ui.Form.Form(
				{
					action: 'MP01/calculate/' + encodeURIComponent( btoa( this.theObject.ObjectNumber ) ),
					classes: [ 'form-horizontal' ],
					invalid: ( inputs: Array<ui.Form.BasicInputField<HTMLElement>> ) =>
					{
						app.addNotify(
						{
							body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.body' ) ) ],
							context: 'danger',
							timeout: Number(app.getConfigValue("ToastTimeout")),
							title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
						});

						this.ResultText = ui.$$.text( app.getMessage( 'BRW.GENERAL.fillAllFields' ) );
					},
					method: 'PUT',
					notSwitchable: true,
					submit: ( methode: ui.Form.FormMethod, action: string, parameter: ui.Form.IFormParameter ) =>
					{
						new Wollmilch.AJAX(
						{
							data: parameter,
							method: methode,
							on:
							{
								beforeSend: ( options: Wollmilch.IAJAXOptions ) =>
								{
									this.ResultText							= ui.$$.text( app.getMessage( 'BRW.GENERAL.result_message' ) );
									this.selectBauartItem				= parameter.buildingkind;
									this.build();

									if ( this.selectGebaeudetypItem === '3' )
									{
										parameter.buildingkind += "/" + this.selectBauartTypItem;
									}

									this.selectBauartTypItem 		= this.selectBauartTypElement.val() as string;

									this.selectAusstattungItem	= this.selectAusstattungElement.val() as string;

									this.AreaSelected						= parameter.area.selected;
									this.AreaValue							= parameter.area.value;
									this.Baujahr								= parameter.baujahr;
									this.Grundstuecksflaeche		= parameter.grundstuecksflaeche;
									this.Garage									= parameter.garage;

									this.lastRequest						= parameter;
								},
								failed: () =>
								{
									this.ResultText = ui.$$.text( app.getMessage( 'BRW.GENERAL.result_failed' ) );
									this.build();
								},
								success: ( text: string ): void =>
								{
									let obj: any = null;
									try
									{
										obj = Wollmilch.jsonize( text );
									}
									catch ( e )
									{
										app.addNotify(
										{
											body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.body' ) ) ],
											context: 'danger',
											timeout: Number(app.getConfigValue("ToastTimeout")),
											title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
										});
										this.ResultText = ui.$$.text( app.getMessage( 'BRW.GENERAL.ERROR.body' ) );
										return;
									}

									if ( obj && !obj.success )
									{
										app.addNotify(
										{
											body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.body' ) ) ],
											context: 'danger',
											timeout: Number(app.getConfigValue("ToastTimeout")),
											title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
										});
										this.ResultText = ui.$$.text( app.getMessage( 'BRW.GENERAL.ERROR.body' ) );
										return;
									}

									if ( obj != null )
									{
										if ( obj.data.Exeptions && obj.data.Exeptions.code )
										{
											app.addNotify(
											{
												body: [ ui.text( obj.data.Exeptions.message + ' (' + obj.data.Exeptions.code + ')' ) ],
												context: 'danger',
												timeout: 5500,
												title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
											});
										}

										this.AreaSelected = obj.data.Properties.area.selected;
										if ( this.AreaSelected === 'livingarea' )
										{
											this.AreaValue	= obj.data.Properties.area.living;
											this.AreaSwap		= obj.data.Properties.area.brutto;
										}
										else
										{
											this.AreaValue	= obj.data.Properties.area.brutto;
											this.AreaSwap		= obj.data.Properties.area.living;
										}
										this.Baujahr 								= obj.data.Properties.buildingyear;
										this.Grundstuecksflaeche		= obj.data.Properties.plotarea;
										this.Garage									= obj.data.Properties.garage;
										this.selectAusstattungItem	= obj.data.Properties.equipments;

										Object.keys( app.getMessage( 'BRW.TYP.' + this.selectGebaeudetypItem + '.equipments' ) )
										.forEach( (element: any) =>
										{
											const value = app.getMessage( 'BRW.TYP.' + this.selectGebaeudetypItem + '.equipments' )[element];
											if ( obj && value === obj.data.Properties.equipments )
											{
												this.selectAusstattungItem = element;
											}
										});

										if ( ! this.selectAusstattungItem )
										{
											this.selectAusstattungItem = this.selectAusstattungElement.val() as string;
										}

										this.buildResultData( obj.data );
										this.build();
									}
								},
							},
							url: action,
						},
						Wollmilch.AJAXCallbase_e.BRW,
						).send();
					},
				},
				)
				.append(
					ui.$$.div().addClass( 'row' )
						.append( ui.$$.div().addClass( 'col-sm-12 col-md-6' )
							.append( this.mMPData.Root() ),
						)
						.append( ui.$$.div().addClass( 'col-sm-12 col-md-6' )
							.append( this.mResultData.Root() ),
						),
				) as ui.Form.Form;

				this.mMPData.addTitle( app.getMessage( 'BRW.GENERAL.LABEL.object' ) );
				this.mResultData.addTitle( app.getMessage( 'BRW.GENERAL.LABEL.result' ) );

				this.append( this.mForm );

				this.mForm.Initialize();

				const btnSubmit = $( this.mForm.Buttons.submit.getElement() ).text( app.getMessage( 'BRW.GENERAL.send' ) );
				const btnCancel = $( this.mForm.Buttons.cancel.getElement() ).text( app.getMessage( 'Aux.ABORT_BTN' ) );

				new ui.Box.Box().append(
					ui.$$.div().append(
						ui.$$.div().append(
							ui.$$.div()
								.append( btnSubmit )
								.append( btnCancel.on( 'click', () => app.getGlobalTabControl().removeTab( this.m_Entry ) ) )
							.addClass( 'col-xs-12' ),
						).addClass( 'row' ),
					).addClass( 'container-fluid' ),
				).appendTo( ui.$$.div().addClass( 'row' ).appendTo( this.mForm.Root() ) ),

				this.rebuild( this.Root() );

				if ( BRWData.Exeptions )
				{
					const RESTError = new SPA.BRW.Exeption( BRWData.Exeptions.code );
					btnSubmit.prop('disabled', true);
					btnSubmit.off();
				}

				if ( BRWData )
				{
					if ( BRWData.Properties )
					{
						this.Baujahr 							= BRWData.Properties.buildingyear;
						this.Grundstuecksflaeche	= BRWData.Properties.plotarea;
						this.Garage								= BRWData.Properties.garage;
						this.AreaSelected 				= BRWData.Properties.area.selected;

						if ( this.AreaSelected === 'livingarea' )
						{
							this.AreaValue	= BRWData.Properties.area.living;
							this.AreaSwap	= BRWData.Properties.area.brutto;
						}
						else
						{
							this.AreaValue	= BRWData.Properties.area.brutto;
							this.AreaSwap	= BRWData.Properties.area.living;
						}

						if ( !BRWData.Properties.buildingkind )
						{
							BRWData.Properties.buildingkind = 1;
						}
						if ( !BRWData.Properties.buildingkindtyp )
						{
							BRWData.Properties.buildingkindtyp = 1;
						}
						if ( !BRWData.Properties.equipments )
						{
							BRWData.Properties.equipments = 1;
						}

						this.selectGebaeudetypItem	= BRWData.Properties.buildingkind.toString()[0];
						if ( this.selectGebaeudetypItem === '3' )
						{
							this.selectGebaeudetypItem = '2';
						}
						if ( this.selectGebaeudetypItem === '4' )
						{
							this.selectGebaeudetypItem = '3';
						}

						this.selectBauartItem				= BRWData.Properties.buildingkind.toString();
						this.selectBauartTypItem		= BRWData.Properties.buildingkindtyp.toString();

						if ( this.selectBauartItem.toString().substr( 0, 1 ) === '3' )
						{
							this.selectBauartTypItem = '3';
						}

						if ( this.selectBauartItem.toString().substr( 0, 1 ) === '4' )
						{
							this.selectBauartTypItem = BRWData.Properties.buildingkind.toString()
								.substr( BRWData.Properties.buildingkind.toString().length - 1 , 1 );
						}

						this.selectAusstattungItem	= BRWData.Properties.equipments.toString();
						this.build();

						this.buildNHKItems( false, true );
					}

					this.buildResultData(BRWData);

					this.build();
					this.buildResultForm();
					this.mResultData.rebuild();
				}

			}

			public rebuild( root: JQuery|ui.base.BaseHTMLElement ): Page
			{
				super.rebuild( root );

				this.build();

				return this;
			}

			private buildMPDataForm(): void
			{
				let fg = ui.$$.div();

				// nur einmal laden
				new SPA.Navigation.BreadCrumb( this.theObject.ObjectNumber ).rebuild( this.mMPData );

				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) =>
				{
					this.mForm.Input( input ); input.Base().addClass( baseclass.join( ' ' ) );
				};

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage('BRW.GENERAL.LABEL.MP01.enum') + '*' )
						.addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.mMPData.Root() );

				const inputArea = new ui.Form.Select(
				{
					name: 'area.selected',
					on:
					{
						change: () =>
						{
							const temp 			= this.AreaSwap;
							this.AreaSwap		= this.AreaValue;
							this.AreaValue 	= temp ;

							this.AreaSelected === 'livingarea' ? this.AreaSelected = 'bruttoarea' : this.AreaSelected = 'livingarea';

							this.build();
						},
					},
					option:
					{
						bruttoarea: app.getMessage( 'BRW.INFO.bruttoarea' ),
						livingarea: app.getMessage( 'BRW.INFO.livingarea' ),
					},
				},
				).value( this.AreaSelected ? this.AreaSelected : 'livingarea' );

				addObjDataInput(
					inputArea.rebuild( fg ),
					[ 'col-xs-12', 'col-md-5' ],
				);

				const inputAreaValue = new ui.Form.NumberInput(
				this.AreaValue,
				{
					min: 0,
					name: 'area.value',
					placeholder: '',
					required: true,
				},
				);
				addObjDataInput( inputAreaValue.rebuild( fg ), [ 'col-xs-12', 'col-md-5' ] );

				fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage('BRW.GENERAL.LABEL.MP01.buildingyear') + '*' )
						.addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.mMPData.Root() );
				const inputBuildingyear = new ui.Form.NumberInput(
				this.Baujahr,
				{
					min: 1800,
					name: 'buildingyear',
					placeholder: '',
					required: true,
				},
				);
				addObjDataInput( inputBuildingyear.rebuild( fg ), [ 'col-xs-12', 'col-md-10' ]);

				fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage('BRW.GENERAL.LABEL.MP01.plotarea') + '*' )
						.addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.mMPData.Root() );
				const inputPlotarea = new ui.Form.NumberInput(
				this.Grundstuecksflaeche,
				{
					min: 0,
					name: 'plotarea',
					placeholder: '',
					required: true,
				},
				);
				addObjDataInput( inputPlotarea.rebuild( fg ), [ 'col-xs-12', 'col-md-10' ] );

				fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage('BRW.GENERAL.LABEL.MP01.garage') )
						.addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.mMPData.Root() );
				const inputGarage = new ui.Form.NumberInput(
				this.Garage,
				{
					min: 0,
					name: 'garage',
					placeholder: '',
					required: false,
				},
				);
				addObjDataInput( inputGarage.rebuild( fg ), [ 'col-xs-12', 'col-md-10' ] );

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage('BRW.GENERAL.LABEL.MP01.buildingtyp') )
						.addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.mMPData.Root() );

				this.selectGebaeudetypElement = new ui.Form.Select(
				{
					on:
					{
						change: () =>
						{
							this.AreaValue = inputAreaValue.val() ? parseInt( inputAreaValue.val()!.toString(), 10 ) : 0;
							this.Grundstuecksflaeche = inputPlotarea.val() ? parseInt( inputPlotarea.val()!.toString(), 10 ) : 0;
							this.Baujahr = inputBuildingyear.val() ? parseInt( inputBuildingyear.val()!.toString(), 10 ) : 0;
							this.Garage = inputGarage.val() ? parseInt( inputGarage.val()!.toString(), 10 ) : 0;

							this.buildNHKItems();
						},
					},
					option:
					{
						1: app.getMessage('BRW.TYP.1.name'),
						2: app.getMessage('BRW.TYP.2.name'),
						3: app.getMessage('BRW.TYP.3.name'),
					},
				},
				this.selectGebaeudetypItem,
				);

				addObjDataInput(
					this.selectGebaeudetypElement.rebuild( fg ),
					[ 'col-xs-12', 'col-md-4' ],
				);

				this.selectBauartTypElement = new ui.Form.RadioGroup(
				{
					inline: 3,
					name: 'buildingTyp',
					on:
					{
						change: () =>
						{
							this.AreaValue = inputAreaValue.val() ? parseInt( inputAreaValue.val()!.toString(), 10 ) : 0;
							this.Grundstuecksflaeche = inputPlotarea.val() ? parseInt( inputPlotarea.val()!.toString(), 10 ) : 0;
							this.Baujahr = inputBuildingyear.val() ? parseInt( inputBuildingyear.val()!.toString(), 10 ) : 0;
							this.Garage = inputGarage.val() ? parseInt( inputGarage.val()!.toString(), 10 ) : 0;

							this.selectBauartTypItem = this.selectBauartTypElement.val() as string;
							this.buildNHKItems( true );
						},
					},
					radioButtons: this.selectBauartTypList,
					required: true,
					value: this.selectBauartTypItem,
				},
				);

				this.selectBauartTypElement.Base().addClass( 'col-xs-12 col-md-6' );
				this.selectBauartTypElement.rebuild( fg ),

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' )
				.append( ui.$$.label().text( app.getMessage('BRW.GENERAL.LABEL.MP01.nhk_object_typ') + '*' )
					.addClass( 'control-label col-xs-12 col-md-2' ) )
				.appendTo( this.mMPData.Root() );

				for (const key in this.selectBauartList) {
					if (this.selectBauartList.hasOwnProperty(key)) {
						const element = this.selectBauartList[key];

						this.selectBauartElement.add(
						{
							Item: this.selectGebaeudetypItem,
							Key: key,
							Name: element,
							Typ: this.selectBauartTypItem,
						},
						( this.selectBauartItem.substring( 2, 4 ) === key ) ? true : false,
						);
					}
				}

				this.selectBauartElement.rebuild( fg );
				this.mForm.Input( this.selectBauartElement );

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage('BRW.GENERAL.LABEL.MP01.equipments') + '*' )
						.addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.mMPData.Root() );
				this.selectAusstattungElement = new ui.Form.Select(
				{
					name: 'equipment',
					option: this.selectAusstattungList,
				},
				this.selectAusstattungItem,
				);
				addObjDataInput(
					this.selectAusstattungElement.rebuild( fg ),
					[ 'col-xs-12', 'col-md-10' ],
				);
			}

			private buildResultForm(): void
			{
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) =>
				{
					this.mForm.Input( input ); input.Base().addClass( baseclass.join( ' ' ) );
				};

				this.mResultData.append(this.ResultText);
			}

			private buildNHKItems( ct: boolean = false, showFromDB: boolean = false ): void
			{
				if ( ct && this.currentobject === this.selectBauartTypItem )
				{
					return;
				}

				if ( !showFromDB )
				{
					this.selectGebaeudetypItem = this.selectGebaeudetypElement.val() as string;
				}

				this.selectBauartList 			= app.getMessage( 'BRW.TYP.' + this.selectGebaeudetypItem + '.list' );
				this.selectBauartTypList 		= [];
				this.selectAusstattungList 	= app.getMessage( 'BRW.TYP.' + this.selectGebaeudetypItem + '.equipments' );

				this.selectBauartElement.clear();

				Object.keys(app.getMessage( 'BRW.TYP.' + this.selectGebaeudetypItem + '.kindof' ))
					.forEach( (element: any) =>
					{
						this.selectBauartTypList[element] =
						{
							title: app.getMessage( 'BRW.TYP.' + this.selectGebaeudetypItem + '.kindof' )[element],
							value: element,
						};
					});

				if ( this.selectGebaeudetypItem === '2' && this.selectBauartTypItem < '2' )
				{
					this.selectBauartTypItem = '2';
				}
				else if ( this.selectGebaeudetypItem === '1' )
				{
					this.selectBauartTypItem = '1';
				}

				this.currentobject = this.selectBauartTypItem;

				this.build();
			}

			private buildResultData( obj: Wollmilch.MP01.IObject ): void
			{
				this.ResultText = ui.$$.div()
				.append( obj.Object.Address ? obj.Object.Address.display : 'no data founded' );

				if ( obj && obj.Indications )
				{
					if ( obj.Indications.status !== Page.SUCCESS )
					{
						const missingParameter: string[] = new Array();

						if ( obj.Indications.status & Page.MISSING )
						{
							if ( ! (obj.Exeptions && obj.Exeptions.code ) )
							{
								this.ResultText.append( ui.$$.hr() )
									.append( ui.$$.text( app.getMessage( 'BRW.GENERAL.WARNING.notspecified' ) ) );
							}
						}
						else
						{
							if ( ! (obj.Exeptions && obj.Exeptions.code ) )
							{
								this.ResultText.append( ui.$$.hr() ).append( ui.$$.text( app.getMessage( 'BRW.INFO.header' ) ) );
							}
						}

						if ( this.AreaSelected === 'livingarea' )
						{
							if ( obj.Indications.status & Page.MISSING_WFL )
							{
								missingParameter.push( app.getMessage( 'BRW.INFO.livingarea' ) );
							}
						}
						else
						{
							if ( obj.Indications.status & Page.MISSING_BGL )
							{
								missingParameter.push( app.getMessage( 'BRW.INFO.bruttoarea' ) );
							}
						}

						if ( obj.Indications.status & Page.MISSING_BJA )
						{
							missingParameter.push( app.getMessage( 'BRW.INFO.buildingyear' ) );
						}
						if ( obj.Indications.status & Page.MISSING_GFL )
						{
							missingParameter.push( app.getMessage( 'BRW.INFO.plotarea' ) );
						}

						if ( missingParameter.length && missingParameter.length > 0 )
						{
							const allParameter = missingParameter.join( ', ' );

							this.ResultText.append( ui.$$.text( allParameter ) ).append( ui.$$.hr() );

							app.addNotify(
							{
								body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.calculate' ) + allParameter ) ],
								context: 'danger',
								timeout: 7500,
								title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
							});
						}
						else
						{
							if ( ! (obj.Exeptions && obj.Exeptions.code ) )
							{
								app.addNotify(
								{
									body: [ ui.text( app.getMessage( 'BRW.GENERAL.WARNING.notspecified' ) ) ],
									context: 'warning',
									timeout: 7500,
									title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.WARNING.title' ) ) ],
								});
							}
						}

					}
					else
					{
						app.addNotify(
						{
							body: [ ui.text( app.getMessage( 'BRW.GENERAL.SUCCESS.calculate' ) ) ],
							context: 'success',
							timeout: Number(app.getConfigValue("ToastTimeout")),
							title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.SUCCESS.title' ) ) ],
						});
					}

					let mTable = new Table( { bordered: false, condensed: true, striped: true, hover: false, column_number: 2 } );

					mTable = this.buildResultTable( mTable, obj.Indications );
					this.ResultText.append( mTable.getTable() );

					this.lastResult = obj;
				}
			}

			private buildResultTable( mTable: Table, indications: Wollmilch.MP01.IIndications ): Table
			{
				mTable.createHeaderRow( 0, [' ', app.getMessage( 'BRW.GENERAL.LABEL.Response.tabHeader' ) ] );

				mTable.createDataRow( -1,
					[ app.getMessage( 'BRW.GENERAL.LABEL.Response.BRW' ),
					(indications.brw ? indications.brw.toFixed(2).toString().replace( '.', ',' ) : 0 ) +
					app.getMessage( 'BRW.GENERAL.LABEL.Response.eurqm' ) ],
				);

				mTable.createDataRow( -1,
					[ app.getMessage( 'BRW.GENERAL.LABEL.Response.provisionallyValue' ),
					(indications.provisionallyValue ? indications.provisionallyValue.toFixed(2).toString().replace( '.', ',' ) : 0) +
					app.getMessage( 'BRW.GENERAL.LABEL.Response.eur' ) ],
				);

				mTable.createDataRow( -1,
					[ app.getMessage( 'BRW.GENERAL.LABEL.Response.marketPrice' ),
					(indications.marketPrice ? indications.marketPrice.toFixed(2).toString().replace( '.', ',' ) : 0) +
					app.getMessage( 'BRW.GENERAL.LABEL.Response.eur' ) ],
				);

				mTable.createDataRow( -1,
					[ app.getMessage( 'BRW.GENERAL.LABEL.Response.source' ),
					indications.sourceInfo ],
				);

				mTable.createDataRow( -1,
					[ app.getMessage( 'BRW.GENERAL.LABEL.Response.qualifyingDate' ),
					indications.qualifyingDate ],
				);

				return mTable;
			}

			private build(): void
			{
				this.mResultData.empty();
				this.mResultData.rebuild().append( ui.$$.br() );

				this.mMPData.rebuild().append( ui.$$.br() );

				this.mForm.clear();
				this.selectBauartElement.clear();

				this.buildMPDataForm();
				this.buildResultForm();
			}

		}

	}

}
